import { twMerge } from 'tailwind-merge'

interface SecondaryBreadcrubmsItemProps extends Partial<Omit<HTMLElement, 'children'>> {
  children: React.ReactNode
  isLast: boolean
}

export default function SecondaryBreadcrubmsItem({
  children,
  isLast,
  className,
}: SecondaryBreadcrubmsItemProps) {
  return <h2 className={twMerge(isLast && 'text-text-primary', className)}>{children}</h2>
}
